'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var ColorImage = require('../common/ColorImage');
var appTypes = require('../../types/appTypes');
var _ = require('underscore');

var TextField = React.createClass({
  render: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var showIcon = styleHelper.getPropertyValue(this.props, propConst.SHOW_ICON);
    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
    var color = styleHelper.getTextColor(this.props);
    var bgColor = '#444';
    if(state === appTypes.ComStatus2.DISABLE){
      color = '#999';
      bgColor = '#999';
    }
    return (
      <div className="text-field-content" style={{
        width: w,
        height: h,
        color : color
      }}>
        {this.renderInput(color)}
        <ColorImage style={{position:'absolute',left:0,bottom:0,width:w - (showIcon?30:0),height:4}} color={bgColor} src={assetsHelper.getComponentAsset('TextField')}/>
        {
          showIcon && <ColorImage color={bgColor} style={{right:0,bottom:0,width:25,height:25,position:'absolute'}} src={assetsHelper.getComponentAsset('Send')}/>
        }
      </div>
    )
  },

  renderInput: function (color) {
    var size = styleHelper.getSize(this.props);

    var style = {
      width: size.width - (this.props.showIcon ? 40 : 0),
      paddingBottom: 2,
      backgroundColor: 'rgba(0,0,0,0)'
    };
    styleHelper.StyleUtil(this.props,style).align().text();
    style.color = color;
    if(_.isUndefined(this.props.canInput) || this.props.canInput){
      return (
        <input style={style} defaultValue={styleHelper.getText(this.props)} />
      );
    }else{
      return (
        <input style={style} disabled defaultValue={styleHelper.getText(this.props)} />
      );
    }
  }
});

module.exports = TextField;



// WEBPACK FOOTER //
// ./src/views/Components/TextField.jsx